import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { Router } from '@angular/router';
import { StateService } from '@cosmos/angular/utils';
import { environment } from 'environments/environment';
import { HttpClient } from '@angular/common/http';
import { TranslatePipe } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { MessageModule } from 'primeng/message';
import { FloatLabelModule } from 'primeng/floatlabel';
import { RouterModule } from '@angular/router';
import { AuthLayoutComponent } from '../auth-layout/auth-layout.component';

@Component({
  selector: 'cosmos-password-recovery',
  imports: [TranslatePipe, FormsModule, ReactiveFormsModule, RouterModule, ButtonModule, InputTextModule, MessageModule, FloatLabelModule, AuthLayoutComponent],
  templateUrl: './password-recovery.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: `
    .form-forgot {
    display: flex;
    justify-content: flex-end;
    margin-top: 0.25rem;

        a {
            font-size: 0.825rem;
            font-weight: 500;
            color: var(--p-primary-color);
            text-decoration: none;
            transition: opacity 0.2s;
            &:hover { opacity: 0.75; }
        }
    }
  `
})
export class PasswordRecoveryComponent implements OnInit {
    private stateService = inject(StateService);
    private router = inject(Router);
    private http = inject(HttpClient);

    email: string = '';
    protected readonly loading = signal(false);
    protected readonly success = signal(false);
    protected readonly error = signal(false);

    ngOnInit(): void {
        if (this.stateService.getCurrentUser()) {
            this.router.navigate(['/']);
        }
    }

    onClick(){
        this.loading.set(true);
        this.success.set(false);
        this.error.set(false);

        this.http.post(`${environment.API_URL}/token/recoveryemail/`, {email: this.email},{observe: 'response'}).subscribe({
            next: () => {
                this.loading.set(false);
                this.success.set(true);
            },
            error: () => {
                this.loading.set(false);
                this.error.set(true);
            },
        });
    }
}
